var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menubar",class:{ 'is-sticky': _vm.sticky, 'is-small': _vm.small, 'is-frontend': _vm.frontend }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }